/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GameModelDto } from '../../models/game-model-dto';

export interface ScoutingControllerGetTeamGamesWithVideoExternal$Params {
  teamUuid: string;
}

export function scoutingControllerGetTeamGamesWithVideoExternal(http: HttpClient, rootUrl: string, params: ScoutingControllerGetTeamGamesWithVideoExternal$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GameModelDto>>> {
  const rb = new RequestBuilder(rootUrl, scoutingControllerGetTeamGamesWithVideoExternal.PATH, 'get');
  if (params) {
    rb.path('teamUuid', params.teamUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GameModelDto>>;
    })
  );
}

scoutingControllerGetTeamGamesWithVideoExternal.PATH = '/scouting/external/{teamUuid}/games';
